import React from 'react';
import ReactPlayer from 'react-player';

const ChangeLogSectionVideo = ({ videoUrl, thumbnail, width = '620px', minHeight = '360px' }) => {
  if (!Boolean(videoUrl?.length)) {
    return <></>;
  }

  return (
    <div className="change-log-section-image-container" style={{ width, minHeight }}>
      <ReactPlayer url={videoUrl} width="100%" height="100%" controls light={thumbnail?.length ? thumbnail : false} />
    </div>
  );
};

export default ChangeLogSectionVideo;